import React from 'react';
import { useQuery } from '@apollo/client';

import { GET_CARE_TEAMS_FOR_AUTOCOMPLETE } from '../gqlSchemas/getCareTeamsForAutocomplete';

function useCareTeamsForAutocompleteRequest(searchCareTeams = '') {
  const {
    data: careTeamsData,
    fetchMore: fetchMoreCareTeams,
    loading: loadingCareTeams,
  } = useQuery(GET_CARE_TEAMS_FOR_AUTOCOMPLETE, {
    fetchPolicy: 'cache-and-network',
    variables: {
      page: 0,
      perPage: 20,
      filter: { name: searchCareTeams },
    },
  });

  const careTeams = careTeamsData?.orgUnit?.careTeamPagination?.items || [];
  const careTeamPageInfo =
    careTeamsData?.orgUnit?.careTeamPagination?.pageInfo || {};

  const loadMore = () => {
    if (!careTeamPageInfo?.hasNextPage) {
      return;
    }

    fetchMoreCareTeams({
      variables: {
        page: (careTeamPageInfo?.page || 0) + 1,
        perPage: 20,
        filter: { name: searchCareTeams },
      },

      updateQuery: (prev, { fetchMoreResult }) => {
        if (!fetchMoreResult) {
          return prev;
        }

        return {
          orgUnit: {
            careTeamPagination: {
              items: [
                ...prev.orgUnit?.careTeamPagination?.items,
                ...fetchMoreResult.orgUnit?.careTeamPagination?.items,
              ],
              pageInfo: {
                ...fetchMoreResult.orgUnit?.careTeamPagination?.pageInfo,
              },
            },
          },
        };
      },
    });
  };

  return {
    careTeams,
    careTeamPageInfo,
    loadingCareTeams,
    loadMore,
  };
}

export default useCareTeamsForAutocompleteRequest;
